import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryTransfer, InventoryTransferItem } from 'src/app/models/inventory/inventory-transfer';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  ExportDataService,
  FunctionsService,
  HttpService,
  TableColumns,
  TableConfiguration,
  MenuBreadCrumb,
  params,
  SessionService
} from 'brainloper-ui';

@Component({
  selector: 'app-inventory-transfer',
  templateUrl: './inventory-transfer.component.html',
  styleUrls: ['./inventory-transfer.component.scss'],
  standalone: false
})
export class InventoryTransferComponent implements OnInit {
  public urlTableIT: string = `${EndpointDictionary.InventoryTransfer.INVENTORY_TRANSFER_TABLE}`;
  private urlItems: string = `${EndpointDictionary.Item.ITEM_COMBO_WAREHOUSE}`;
  private urlUser: string = `${EndpointDictionary.User.USER_COMBO}`;
  private urlWarehouses: string = `${EndpointDictionary.Warehouse.WAREHOUSE_COMBO}`;

  public selected = new UntypedFormControl(0);
  public reloadTablaIT = new EventEmitter<any>();

  public labels = [];
  public params = [{ id: 'active', value: 1 }];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Inventario',
    },
    {
      name: 'Traslado de Inventario',
      current: true,
    },
  ];

  public columnsTableIT: Array<TableColumns<InventoryTransfer>> = [
    {
      ID: 'consecutive',
      label: 'Consecutivo',
      type: 'number',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'userName',
      label: 'Usuario',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'originWarehouseName',
      label: 'Bodega Origen',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'destinationWarehouseName',
      label: 'Bodega Destino',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'itemsCount',
      label: 'Cant. de Ítems',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCost',
      label: 'Costo Total',
      type: 'currency',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
  ];

  public configTable: TableConfiguration = {
    add: true,
    view: true,
    selectable: false,
    addPer: true,
    primaryKey: 'id',
    hideTitle: true,
    exportXslx: true,
    delete: false,
    exportXslxByRow: false,
    sendEmail: false,
    print: false
  };

  headerFileXlsm: Array<params> = [
    { id: 'consecutive', value: 'Consecutivo' },
    { id: 'date', value: 'Fecha' },
    { id: 'userName', value: 'Usuario' },
    { id: 'originWarehouseName', value: 'Bodega Origen' },
    { id: 'destinationWarehouseName', value: 'Bodega Destino' },
    { id: 'itemsCount', value: 'Cant. de Ítems' },
    { id: 'totalCost', value: 'Costo Total' },
    {id:"transferConsecutive", value:"# Traslado"},
    {id:"destinationWarehouseName", value:"Bodega destino"},
  ];

  //tabla detalle
  public reloadTablaDetails = new EventEmitter<any>();
  public dataDetails: Array<InventoryTransferItem> = [];
  public configurationDetails: TableConfiguration = {
    exportXslx: true,
    hideTitle: true,
    primaryKey: 'id',
  };
  public columnsDetails: TableColumns<InventoryTransferItem>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'itemName',
      label: 'Ítem',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad de Medida',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad Trasladada',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Unitario',
      type: 'currency',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCost',
      label: 'Costo Total',
      type: 'currency',
      style: {
        textAlign: 'center',
      },
    },
  ];

  headerDetailsFileXlsm: Array<params> = [
    { id: 'code', value: 'Código Item' },
    { id: 'itemName', value: 'Ítem' },
    { id: 'unitMeasurement', value: 'Unidad de Medida' },
    { id: 'amount', value: 'Cantidad Trasladada' },
    { id: 'costItem', value: 'Costo Unitario' },
    { id: 'totalCost', value: 'Costo Total' },
  ];

  constructor(
    private router: Router,
    private http: HttpService,
    private functionEter: FunctionsService,
    private exportData: ExportDataService,
    private session: SessionService,
    private activeRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {}

  async viewItem($event: Array<InventoryTransfer>): Promise<void> {
    let item = $event[0];
    let res = await this.http.getDataBody<Array<InventoryTransfer>>(
      `${EndpointDictionary.InventoryTransfer.CRUD_INVENTORY_TRANSFER}/${item.id}`
    );
    if (res) {
      this.dataDetails = res[0].items;
      this.labesFunction(res[0]);
      this.setHeaderFileXlsm(res[0]);
      this.selected.setValue(1);
    }
  }

  private setHeaderFileXlsm(transfer: InventoryTransfer) {
    this.headerDetailsFileXlsm[6] = {
      id: null,
      value: `Consecutivo (#): ${transfer.consecutive}`,
    };
    this.headerDetailsFileXlsm[7] = {
      id: null,
      value: `Usuario: ${transfer.userName}`,
    };
    this.headerDetailsFileXlsm[8] = {
      id: null,
      value: `Fecha: ${this.functionEter.dateDB(new Date(transfer.date))}`,
    };
    this.headerDetailsFileXlsm[9] = {
      id: null,
      value: `Costo Total: $  ${Intl.NumberFormat('es-CO').format(transfer.totalCost)}`,
    };
  }

  private labesFunction(data: InventoryTransfer) {
    this.labels = [
      {
        label: 'Consecutivo (#):',
        value: data.consecutive,
        edit: false,
      },
      {
        label: 'Usuario:',
        value: data.userName,
        edit: false,
      },
      {
        label: 'Fecha:',
        value: this.functionEter.dateDB(new Date(data.date)),
        edit: false,
      },
      {
        label: 'Bodega Origen:',
        value: data.originWarehouseName,
        edit: false,
      },
      {
        label: 'Bodega Destino:',
        value: data.destinationWarehouseName,
        edit: false,
      },
      {
        label: 'Total:',
        value: `$  ${Intl.NumberFormat('es-CO').format(data.totalCost)}`,
        edit: false,
      },
    ];
    if (data?.comment && data.comment != '') {
      this.labels.push({
        label: 'Comentario:',
        value: data.comment,
        edit: false,
      });
      this.headerDetailsFileXlsm[10] = {
        id: null,
        value: `Comentario: ${data.comment}`,
      };
    }
    
  }

  public newItem(event: any): void {
    this.session.setData('inventoryTransfer', {});
    this.router.navigate(['detalle'], { relativeTo: this.activeRoute })
  }
}
